/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostPersonalHealthRecordZipExportGenerateResponseTypename =
  "PostPersonalHealthRecordZipExportGenerateResponse" as const;

/**
 *
 * @export
 * @interface PostPersonalHealthRecordZipExportGenerateResponse
 */
export interface PostPersonalHealthRecordZipExportGenerateResponse {
  /**
   *
   * @type {string}
   * @memberof PostPersonalHealthRecordZipExportGenerateResponse
   */
  id: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostPersonalHealthRecordZipExportGenerateResponse
   */
  readonly __typename?: string;
}

export function PostPersonalHealthRecordZipExportGenerateResponseFromJSON(
  json: any
): PostPersonalHealthRecordZipExportGenerateResponse {
  return PostPersonalHealthRecordZipExportGenerateResponseFromJSONTyped(json, false);
}

export function PostPersonalHealthRecordZipExportGenerateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostPersonalHealthRecordZipExportGenerateResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostPersonalHealthRecordZipExportGenerateResponseTypename,

    id: json["id"],
  };
}

export function PostPersonalHealthRecordZipExportGenerateResponseToJSON(
  object?: PostPersonalHealthRecordZipExportGenerateResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    id: value.id,
  };
}
